import React from 'react'
import PropTypes from 'prop-types'
import {
  Dialog,
  Typography,
  withStyles,
  Icon,
  IconButton,
} from '@material-ui/core'

import { CLOSE } from 'app/constants/button'
import ContainedButton from 'app/componentV4/Button/ContainedButton'
import OutlinedButtons from 'app/componentV4/Button/OutlinedButtons'

const CustomsSubmitDialog = withStyles({
  root: {
    '& .MuiDialog-paper': {
      width: '375px !important',
      overflowX: 'auto',
    },
  },
})(Dialog)

const SubmitDialog = (props) => {
  const {
    id,
    type,
    open = false,
    title,
    onClose,
    children,
    onSubmit,
    closeText,
    className,
    submitText,
    description,
    isLoading = false,
    disabledSubmit = false,
    textAlign = 'text-center',
  } = props

  return (
    <CustomsSubmitDialog
      id={id}
      open={open}
      onClose={onClose}
      className={className}
      aria-labelledby={id}
    >
      <div className="p-2 flex justify-end w-full">
        <IconButton
          aria-owns="close button"
          aria-haspopup="true"
          className="p-4"
          disabled={isLoading}
          onClick={() => onClose()}
        >
          <Icon color="action" className="text-24 text-blue-950 font-600">
            close
          </Icon>
        </IconButton>
      </div>
      <div className="px-10 pb-10">
        <Typography className={`text-lg font-bold text-primary ${textAlign}`}>
          {title}
        </Typography>
        <div className="my-5">
          <Typography className={`text-md text-primary ${textAlign}`}>
            {description}
          </Typography>
        </div>
        {children}
        <div className="flex justify-center space-x-5 mt-5">
          <OutlinedButtons
            id={`close-${id}`}
            color={CLOSE}
            onClick={() => onClose()}
            aria-checked={false}
          >
            {closeText}
          </OutlinedButtons>
          <ContainedButton
            id={`submit-${id}`}
            color={type}
            onClick={() => onSubmit()}
            disabled={disabledSubmit || isLoading}
            isLoading={isLoading}
            aria-disabled={disabledSubmit || isLoading}
          >
            {submitText}
          </ContainedButton>
        </div>
      </div>
    </CustomsSubmitDialog>
  )
}

SubmitDialog.propTypes = {
  id: PropTypes.string,
  open: PropTypes.bool,
  type: PropTypes.string,
  title: PropTypes.string,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  children: PropTypes.node,
  closeText: PropTypes.node,
  isLoading: PropTypes.bool,
  submitText: PropTypes.node,
  className: PropTypes.string,
  description: PropTypes.string,
  disabledSubmit: PropTypes.bool,
}
export default SubmitDialog
